import Topbar from "./topbar.jsx"

export default function () {
  return {
    components: {
      Topbar
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/topbar/index.js